import { APPLICATION_FUNCTION_EXTERNAL_ID, PageArea } from '..'
import Loading from '../../components/process-state-notifications/Loading'
import {
  SingleColumnSheetArea,
  SingleColumnSheetBody,
} from '../../containers/SingleSheetV2'
import { BasicInformationTable } from '../../containers/SingleSheetV2/table'
import { useSingleSheetFormValidation } from '../../containers/SingleSheetV2/hooks/formValidation'
import { useSubmitButton } from '../../containers/SingleSheetV2/hooks/submitButton'
import { useSingleSheetKeyBind } from '../../containers/SingleSheetV2/hooks/keyBind'
import { MultiLineTextTabDef } from '../../containers/SingleSheetV2/tab/model'
import { useApplicationFunctionUuid } from '../../hooks/useApplicationFunctionUuid'
import {
  useFinancialYearEndMonthOptions,
  useTimezoneOptions,
} from '../../hooks/useCustomEnumSelectOptions'
import { useTenantBasicInformationTableDef } from './components/basicInformationTableDef'
import { TenantSubHeader } from './components/subheader'
import { useTenantEditData } from './hooks/tenantEditData'
import { useTenantModelModifier } from './hooks/tenantModelModifier'

// この単票は複数行テキストのタブを持たない。バリデーションフックの参照を安定させ
// セルのメモ化を壊さないよう、空配列を共有する。
const NO_MULTILINE_TEXT_TAB_DEFS: MultiLineTextTabDef[] = []

const doNothing = () => undefined

// テナント設定画面。更新のみで、作成・削除・ログインの導線を持たない。
export const TenantEdit = () => {
  const {
    isInitialized,
    isLoading,
    isSubmitting,
    edited,
    editedFormData,
    formModel,
    onChangeTenant,
    submit,
    reload,
  } = useTenantEditData()
  const timezoneOptions = useTimezoneOptions()
  const financialYearEndMonthOptions = useFinancialYearEndMonthOptions()
  const tableDef = useTenantBasicInformationTableDef({
    timezoneOptions,
    financialYearEndMonthOptions,
  })
  const functionUuid = useApplicationFunctionUuid(
    APPLICATION_FUNCTION_EXTERNAL_ID.TENANT_EDIT
  )
  const {
    validate,
    validateAllProperties,
    validationErrors,
    hasValidationErrors,
  } = useSingleSheetFormValidation(tableDef, NO_MULTILINE_TEXT_TAB_DEFS, edited)
  const formModelModifiers = useTenantModelModifier(onChangeTenant, validate)
  const { onClickSubmitButton, submitButtonIsActive } = useSubmitButton(
    submit,
    edited,
    formModel,
    hasValidationErrors,
    validateAllProperties
  )
  const isBusy = isLoading || isSubmitting
  // 再取得中はeditedと前回の取得結果が残ったままのため、リロードで破棄を選んだ
  // 直後に保存すると破棄したはずの編集内容が送信されてしまう。
  const handleSubmit = isBusy ? doNothing : onClickSubmitButton
  useSingleSheetKeyBind(handleSubmit, functionUuid)

  // この機能の権限が無いユーザーには画面を表示しない。
  if (!functionUuid) return <></>

  return (
    <PageArea>
      <Loading isLoading={isLoading} />
      {/* 取得に失敗して単票を描画できない場合でも画面内のリロードで復帰できるよう、
          サブヘッダーは取得結果に依らず表示する。 */}
      <TenantSubHeader
        canSubmit={submitButtonIsActive && !isBusy}
        onSubmit={handleSubmit}
        onReload={reload}
        isEdited={edited}
        isBusy={isBusy}
      />
      {isInitialized && (
        <SingleColumnSheetArea>
          <SingleColumnSheetBody>
            <BasicInformationTable
              dataUuid={formModel.uuid}
              tableDef={tableDef}
              formModel={formModel}
              formModelModifiers={formModelModifiers}
              editedFormData={editedFormData}
              validationErrors={validationErrors}
            />
          </SingleColumnSheetBody>
        </SingleColumnSheetArea>
      )}
    </PageArea>
  )
}
